import React, { useState } from "react";
import ControlPanel from "./ControlPanel/ControlPanel";
import { eventStatuses } from "../../misc/constants";

export const DateInput = () => {
  const [selectedDate, setSelectedDate] = useState("");

  const handleChange = (event) => {
    setSelectedDate(event.target.value);
  };

  return (
    <div className="text-center border border-gray-300 rounded-lg px-4 py-2 w-36 flex">
      <input
        type="date"
        className="outline-none w-28"
        value={selectedDate}
        onChange={handleChange}
      />
    </div>
  );
};

export default function EventCard({ event }) {
  const [title, setTitle] = useState(event.title);
  const [descr, setDescr] = useState(event.descr);
  const [isUrlChecked, setIsUrlChecked] = useState(!!event.url);
  const [url, setUrl] = useState(event.url);

  const handleUrlChange = (e) => {
    const newUrl = e.target.value;
    setUrl(newUrl);
  };
  const handleCheckboxChange = () => {
    setIsUrlChecked((prev) => !prev);
  };
  const handleChangeTitle = (e) => {
    const newTitle = e.target.value;
    if (newTitle.length <= 60) {
      setTitle(newTitle);
    }
  };
  const handleChangeDescr = (e) => {
    const newDescr = e.target.value;
    if (newDescr.length <= 800) {
      setDescr(newDescr);
    }
  };
  return (
    <div className="text-black bg-white flex flex-col p-6 gap-6 w-full rounded-xl">
      <div className="flex gap-1 items-center w-full ml-4">
        <img
          src={
            event.status === eventStatuses[0].status
              ? eventStatuses[0].img
              : event.status === eventStatuses[1].status
              ? eventStatuses[1].img
              : eventStatuses[2].img
          }
          alt="status-icon"
        />

        <p
          style={{
            color:
              event.status === eventStatuses[0].status
                ? eventStatuses[0].color
                : event.status === eventStatuses[1].status
                ? eventStatuses[1].color
                : eventStatuses[2].color,
          }}
          className="font-medium text-base"
        >
          {event.status}
        </p>
      </div>

      <div className="flex gap-6">
        <div>
          <p>Обложка события</p>
          <div>
            <img className="rounded-lg" src={event.img} alt="img" />
            <p className="text-[#AFB7CA] text-xs font-medium mt-[2px]">
              JPG, PNG | Не более 1200x800px, 10MB
            </p>
          </div>
        </div>

        <div>
          <div className="flex flex-col gap-3">
            <div className="flex gap-2">
              <input
                type="checkbox"
                checked={isUrlChecked}
                onChange={handleCheckboxChange}
              />
              <p>Внешняя ссылка</p>
            </div>
            <input
              className="px-4 py-3 outline-none bg-[#F0F3FA] rounded-lg placeholder-[#AFB7CA]"
              type="text"
              placeholder="Ссылка на внешний ресурс события"
              value={url}
              onChange={handleUrlChange}
            />
            <input
              className="px-4 py-3 outline-none bg-[#F0F3FA] rounded-lg placeholder-[#AFB7CA]"
              type="text"
              placeholder="Надпись на кнопке со ссылкой"
            />
          </div>

          <div className="flex mt-6 gap-6">
            <div className="flex gap-2">
              <input type="checkbox" name="" id="" />
              <p>Отложенная публикация</p>
            </div>
            <div className="flex gap-2">
              <input
                type="checkbox"
                name=""
                id=""
                className="border-[#AFB7CA]"
              />
              <p>Сбор заявок</p>
            </div>
          </div>

          {/* <div className="text-center border border-gray-300 rounded-lg px-4 py-2 w-36">
            <p>Дата</p>
            <input type="date" className="outline-none w-28" />
          </div> */}

          <DateInput />
        </div>
      </div>

      <div className="">
        <p className="text-[#5F6B88] font-medium text-sm">Заголовок события</p>
        <input
          className="bg-[#F0F3FA] w-full px-4 py-3 rounded-lg mt-2 outline-none"
          type="text"
          value={title}
          onChange={handleChangeTitle}
        />
        <p className="text-[#AFB7CA] text-xs font-medium ml-4">
          {title.length}/60
        </p>
      </div>

      <div>
        <p className="text-[#5F6B88] font-medium text-sm">Текст события</p>
        <textarea
          onChange={handleChangeDescr}
          className="bg-[#F0F3FA] w-full px-4 py-3 rounded-lg resize-none mt-2 h-[25vh] outline-none"
          placeholder="Текст описания"
        />
        <p className="text-[#AFB7CA] text-xs font-medium ml-4">
          {descr.length}/800
        </p>
      </div>

      <ControlPanel />
    </div>
  );
}
